/* eslint-disable */
/**
 * Types of tracking:-
 * UBA
 * Error - called as nlogger
 * HeatMap
 * TNM
 */

/**
 * Syntax of ntrack function:
 * Tracking covered in nTrack- UBA
 * nTrack(
 *   {
 *     uba: ubaObject,   // uba Object - Already populated Object
 *   }
 * )
 * eg:
 * nTrack({
 *   uba: {
 *     pageName: 'applyHistory',
 *     eventName: 'applyHistoryView',
 *     keyNames: {
 *       actionType: "view",
 *       referrer: this.props.route.previous
 *     }
 *   }
 * });
 */
export interface UbaObject {
  pageName: string;
  eventName: string;
  keyNames: {
    actionType: string;
    referrer?: string;
  };
}

export function uba({ eventName, ubaData }: any): void {
  try {
    (window as any).ub.track(eventName, ubaData);
  } catch (e) {
    console.warn(e);
  }
}

/**
 * This is a common tracking function mainly responsible to send all kind of tracking
 * like 'newMonk tracking', 'GA tracking', 'UBA tracking' to server(naukri or third party(google)).
 */
export interface NTrackObject {
  uba?: UbaObject | UbaObject[];
}

export function nTrack(obj: NTrackObject): void {
  try {
    // trigger uba
    if (obj && obj.uba) {
      uba(obj.uba);
    }
  } catch (e) {
    console.warn(e);
  }
}

/** Singleton Service for page(eg:JD) tracking for common uba parameters */
const tracking = (function () {
  let commonUbaData: Record<string, any> = {};
  let pageName: string;

  const init = (
    keyNames: Record<string, any> = {},
    mainParams: { pageName?: string } = {},
  ): void => {
    commonUbaData = { ...commonUbaData, ...keyNames };
    pageName = mainParams.pageName || pageName;
  };

  const populateUbaObj = (
    pagename: string,
    commonUbaDataObj: Record<string, any>,
    keyNames: Record<string, any>,
  ): any => {
    let ubaReferrer;

    if (
      (window as any).referrer &&
      (window as any).referrer.UBA !== undefined
    ) {
      ubaReferrer = (window as any).referrer.UBA;
      (window as any).referrer.UBA = undefined;
    } else if (keyNames && keyNames.referrer) {
      ubaReferrer = keyNames.referrer;
    }

    return {
      pageName: pagename,
      ...commonUbaDataObj,
      ...keyNames,
      referrer: ubaReferrer || document.referrer,
    };
  };

  const doTracking = (trackingData: any): void => {
    let ubaObj;

    if (trackingData.uba && Array.isArray(trackingData.uba)) {
      const ubaArr: UbaObject[] = [];
      const eventslen = trackingData.uba.length;
      trackingData.uba.forEach((obj: UbaObject) => {
        const tempObj = {
          eventName: obj.eventName,
          ...populateUbaObj(pageName, commonUbaData, obj.keyNames),
          eventType: "bulk",
          eventslen,
        };
        ubaArr.push(tempObj);
      });
      ubaObj = {
        ubaData: ubaArr,
      };
    } else if (trackingData.uba) {
      ubaObj = {
        eventName: trackingData.uba.eventName,
        ubaData: populateUbaObj(
          pageName,
          commonUbaData,
          trackingData.uba.keyNames,
        ),
      };
    }

    if (ubaObj) {
      nTrack({
        ...trackingData,
        uba: ubaObj,
      });
    } else {
      nTrack(trackingData);
    }
  };

  return { init, doTracking };
})();

// Extend the window object with the tracking service
(window as any).tracking = tracking;
